import ownerEditComponent from './owner-edit.component';

const ownerEditModule = angular.module('ownerEdit', [
])
  .component('ownerEdit', ownerEditComponent)
  .name;

export default ownerEditModule;
